import { render, staticRenderFns } from "./r-item-state-action.vue?vue&type=template&id=e8503820"
import script from "./r-item-state-action.vue?vue&type=script&lang=js"
export * from "./r-item-state-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8503820')) {
      api.createRecord('e8503820', component.options)
    } else {
      api.reload('e8503820', component.options)
    }
    module.hot.accept("./r-item-state-action.vue?vue&type=template&id=e8503820", function () {
      api.rerender('e8503820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/r-item-state-action.vue"
export default component.exports